import { combineReducers } from 'redux';
import activitiesReducer from './activitiesReducer';
import loginReducer from './loginReducer';
import messageReducer from './messageReducer';
import runningProgramReducer from './runningProgramReducer';
import loadingReducer from './loadingReducer'
import futureActivitiesReducer from './futureActivitiesReducer';



export default combineReducers({
    activities: activitiesReducer,
    auth: loginReducer,
    runningProgram: runningProgramReducer,
    message: messageReducer,
    loading: loadingReducer,
    plan:futureActivitiesReducer,
});